import { StateStorage } from 'zustand/middleware';

const memoryStorage = new Map<string, string>();

const inMemoryStateStorage: StateStorage = {
  getItem: (name: string) => memoryStorage.get(name) ?? null,
  setItem: (name: string, value: string) => {
    memoryStorage.set(name, value);
  },
  removeItem: (name: string) => {
    memoryStorage.delete(name);
  },
};

export const getPersistStorage = (): StateStorage => {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage;
    }
  } catch {
    // Use in-memory storage in test/non-browser environments.
  }

  return inMemoryStateStorage;
};
